// src/pages/beta-community/components/OfferSection.jsx
import React from 'react';

const OfferSection = () => {
  const offers = [
    {
      number: '01',
      title: '6 mois 100% offerts',
      description: 'Accès au plan bêta sélectionné sans engagement pendant la période de test (valeur selon formule : 174€ à 1.794€)'
    },
    {
      number: '02',
      title: 'Tarif fondateur',
      description: 'Tarif privilégié gelé après la période beta, même en cas d\'augmentation des prix publics'
    },
    {
      number: '03',
      title: 'Accès anticipé',
      description: 'Testez les modules clés avant lancement public : inventaire, partage, rapports, IA selon votre plan et workflows professionnels'
    },
    {
      number: '04',
      title: 'Influence directe',
      description: 'Vos retours aident à clarifier les parcours collectionneur, Art Advisor, Family Office et CGP'
    },
    {
      number: '05',
      title: 'Support dédié',
      description: 'Accompagnement d’onboarding, retours structurés et aide à la prise en main'
    },
    {
      number: '06',
      title: 'Badge Founding',
      description: 'Statut de membre fondateur bêta, utile pour identifier les premiers contributeurs de la plateforme'
    }
  ];

  return (
    <section className="section offer-section">
      <div className="container">
        <h2 className="section-title">Ce que vous apporte la Beta Community</h2>
        
        <div className="offer-grid">
          {offers.map((offer, index) => (
            <div key={index} className="offer-item">
              <div className="offer-number">{offer.number}</div>
              <h3 className="offer-title">{offer.title}</h3>
              <p className="offer-desc">{offer.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OfferSection;